import NoDataForSelection from 'components/atoms/NoDataForSelection';
import TileButton, { tileDataProp } from 'components/atoms/TileButton';
import MainSection from 'components/template/BumpReport/MainSection';
import { UserContext } from 'contexts/ConfigContext';
import { FilterContextData } from 'contexts/FilterContext';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { getConfig } from 'utils/helperMethods';
import { commonClassName, commonHeaderClass } from './PromoScorecard';
import { trackEventMixpanel } from 'utils/mixpanel';
import {
    BUMP_REPORT_ABS_TAB_CLICKED,
    BUMP_REPORT_MAIN_TAB_CLICKED,
    BUMP_REPORT_VALUE_TAB_CLICKED,
} from 'utils/mixpanelEventNames';
import { Switch } from 'antd';

// export const groupByKey = 'groupBy';
// const bumpReportTileData = [
//     { key: 'increments', label: 'Increments' },
//     { key: 'promo', label: 'Promo' },
//     { key: groupByKey, label: 'Group By' },
// ];

const BumpReport = () => {
    const { appConfig } = useContext(UserContext);
    const bumpReportConfig = getConfig('bumpReport', appConfig);
    const commonConfig = getConfig('commonConfig', appConfig);
    const volGroupByOptionsMapping = bumpReportConfig.volGroupByOptionsMapping;
    const { absTileData, volTileData, bumpReportTileData, groupByKey } = bumpReportConfig;
    const { filterNullError } = useContext(FilterContextData);
    const filterContext = useContext(FilterContextData);
    const [bumpReportTile, setBumpReportTile] = useState(bumpReportTileData[0]);
    const [absTile, setAbsTile] = useState(absTileData[0]);
    const [volTile, setVolTile] = useState(volTileData[0]);
    const bumpChartY2AxisOptions = bumpReportConfig.bumpChartY2AxisOptions;
    const [loading, setLoading] = useState(false);
    const [groupByOptionSelected, setGroupByOptionSelected] = useState(volGroupByOptionsMapping[volTile.key][0]);
    const [optionSelected, setOptionSelected] = useState([bumpChartY2AxisOptions[volTile.key][0].value]);
    const [showAllLabels, setShowAllLabels] = useState(false);
    const tileDataMemoized = useMemo(() => {
        return {
            absTile,
            volTile,
            bumpReportTile,
        };
    }, [absTile, volTile, bumpReportTile]);
    return (
        <section className={`${commonClassName} bg-white`}>
            {filterNullError ? (
                <NoDataForSelection />
            ) : (
                <div>
                    <div className="flex justify-between items-center">
                        <div className="flex justify-start items-center gap-4">
                            <h2 className={commonHeaderClass}>{bumpReportConfig?.mainHeader}</h2>
                            <TileButton
                                disabled={loading}
                                data={bumpReportTileData}
                                activeKey={bumpReportTile.key}
                                onClick={(item: any) => {
                                    setBumpReportTile(item);
                                    //mixpanel event
                                    trackEventMixpanel(BUMP_REPORT_MAIN_TAB_CLICKED, {
                                        tabName: item.label,
                                    });
                                }}
                            />
                        </div>
                        <div className="flex items-center gap-4">
                            <div className="flex items-center">
                                <span className="font-xs text-blackAlt mr-1">Show Label</span>
                                <Switch onChange={(val) => setShowAllLabels(val)} checked={showAllLabels} />
                            </div>
                            <TileButton
                                disabled={loading}
                                data={absTileData}
                                activeKey={absTile.key}
                                onClick={(item: tileDataProp) => {
                                    setAbsTile(item);
                                    //mixpanel event
                                    trackEventMixpanel(BUMP_REPORT_ABS_TAB_CLICKED, {
                                        tabName: item.label,
                                    });
                                }}
                            />
                            <TileButton
                                disabled={loading}
                                data={volTileData}
                                activeKey={volTile.key}
                                onClick={(item: tileDataProp) => {
                                    setGroupByOptionSelected(volGroupByOptionsMapping[item.key][0]);
                                    setOptionSelected([bumpChartY2AxisOptions[item.key][0]]);
                                    setVolTile(item);
                                    //mixpanel event
                                    trackEventMixpanel(BUMP_REPORT_VALUE_TAB_CLICKED, {
                                        tabName: item.label,
                                    });
                                }}
                            />
                        </div>
                    </div>
                    <MainSection
                        showAllLabels={showAllLabels}
                        setLoading={setLoading}
                        groupByOptionSelected={groupByOptionSelected}
                        setGroupByOptionSelected={setGroupByOptionSelected}
                        optionSelected={optionSelected}
                        setOptionSelected={setOptionSelected}
                        tileData={tileDataMemoized}
                    />
                </div>
            )}
        </section>
    );
};

export default BumpReport;
